export default __webpack_public_path__ + "static/media/timor.850b84c9.png";